import {LANGUAGE} from '@/common/utils/constants';

export const PROJECT_FORMS_VALIDATIONS_TRANSLATIONS = {
	[LANGUAGE.en.short]: {
		isRequired: "This field is required.",
		minString: "This field should have minimum {min} characters.",
		maxString: "This field should not have more than {max} characters.",
		email: "Email is not valid.",
		maxFileSize: "Maximum size of a photo is 5MB.",
		fileType: "Allowed formats - jpeg and png.",
		validaDate: "End date should be after Start date.",
		testimonialsFillAll: "Please fill out all fields in order to create new testimonial.",
		testimonialsMaxCount: "You can add up to 5 testimonials. For more testimonials please contact our <a href='mailto:feedback.drc@akkodis.com'>CMT team</a>.",
		serviceLines: "Type of business field is required.",
		techPractices: "Tech practices field is required.",
		links: "External link field should be valid.",
		maxFileCount: "You can upload up to 5 images.",
		industry: "The industry is required.",
		urlValid: "Url format verification: the as it is the current one",
		fillAllToAddLInk: "Please fill out all fields in order to create new link",
		translationsValidationsError: "Please approve or update all sections above.",
		theFieldContainsUnallowedHtmlTags: "The field contains unallowed HTML tags.",
		cancel: "Cancel",
		continue: "Continue",
		validationFormResetFieldMessage: "Are you sure you want to reset it? The changes will be lost.",
		jobTitle: 'Job Title',
		authorName: 'Author Name',
		tooLong2000: "This field should not have more than 2000 characters.",
		tooLong10000: "This field should not have more than 10000 characters.",
	},
	[LANGUAGE.it.short]: {
		isRequired: "Questo campo è obbligatorio.",
		minString: "Questo campo dovrebbe avere almeno {min} caratteri.",
		maxString: "Questo campo non dovrebbe avere più di {max} caratteri.",
		email: "L'email non è valida.",
		maxFileSize: "La dimensione massima di una foto è di 5 MB.",
		fileType: "Formati consentiti - JPEG e PNG.",
		validaDate: "La data di fine dovrebbe essere dopo la data di inizio.",
		testimonialsFillAll: "Si prega di compilare tutti i campi per creare una nuova testimonianza.",
		testimonialsMaxCount: "Puoi aggiungere fino a 5 testimonianze. Per ulteriori testimonianze, contatta il nostro <a href='mailto:feedback.drc@akkodis.com'>team CMT</a>.",
		serviceLines: "Il campo Tipo di attività è obbligatorio.",
		techPractices: "È richiesto il campo delle pratiche tecnologiche.",
		links: "Il campo di collegamento esterno dovrebbe essere valido.",
		maxFileCount: "Puoi caricare fino a 5 immagini.",
		industry: "L'industria è richiesta.",
		urlValid: "Verifica del formato dell'url: il come è quello attuale",
		fillAllToAddLInk: "Si prega di compilare tutti i campi per creare un nuovo collegamento",
		translationsValidationsError: "Si prega di approvare o aggiornare tutte le sezioni precedenti.",
		theFieldContainsUnallowedHtmlTags: "Il campo contiene tag HTML non consentiti.",
		cancel: "Annulla",
		continue: "Continua",
		validationFormResetFieldMessage: "Sei sicuro di volerlo resettare? Le modifiche andranno perse.",
		jobTitle: 'Titolo di lavoro',
		authorName: 'Nome dell\'autore',
		tooLong2000: "Questo campo non dovrebbe avere più di 2000 caratteri.",
		tooLong10000: "Questo campo non dovrebbe avere più di 10000 caratteri.",
	},
	[LANGUAGE.de.short]: {
		isRequired: "Dieses Feld ist erforderlich.",
		minString: "Dieses Feld sollte mindestens {min} Zeichen haben.",
		maxString: "Dieses Feld sollte nicht mehr als {max} Zeichen haben.",
		email: "Email ist ungültig.",
		maxFileSize: "Die maximale Größe eines Fotos beträgt 5 MB.",
		fileType: "Erlaubte Formate - JPEG und PNG.",
		validaDate: "Enddatum sollte nach dem Startdatum erfolgen.",
		testimonialsFillAll: "Bitte füllen Sie alle Felder aus, um ein neues Zeugnis zu erstellen.",
		testimonialsMaxCount: "Sie können bis zu 5 Testimonials hinzufügen. Für weitere Erfahrungsberichte wenden Sie sich bitte an unser <a href='mailto:feedback.drc@akkodis.com'>CMT-Team</a>.",
		serviceLines: "Das Feld „Art des Unternehmens“ ist ein Pflichtfeld.",
		techPractices: "Tech Practices -Feld ist erforderlich.",
		links: "Das externe Verknüpfungsfeld sollte gültig sein.",
		maxFileCount: "Sie können bis zu 5 Bilder hochladen.",
		industry: "Die Industrie ist gefragt.",
		urlValid: "Überprüfung des URL-Formats: so wie es aktuell ist",
		fillAllToAddLInk: "Bitte füllen Sie alle Felder aus, um einen neuen Link zu erstellen",
		translationsValidationsError: "Bitte genehmigen oder aktualisieren Sie alle oben genannten Abschnitte.",
		theFieldContainsUnallowedHtmlTags: "Das Feld enthält unzulässige HTML-Tags..",
		cancel: "Stornieren",
		continue: "Weitermachen",
		validationFormResetFieldMessage: "Sind Sie sicher, dass Sie es zurücksetzen möchten? Die Änderungen gehen verloren.",
		jobTitle: 'Berufsbezeichnung',
		authorName: 'Autorenname',
		tooLong2000: "Dieses Feld sollte nicht mehr als 2000 Zeichen haben.",
		tooLong10000: "Dieses Feld sollte nicht mehr als 10000 Zeichen haben.",
	},
	[LANGUAGE.fr.short]: {
		isRequired: "Ce champ est requis.",
		minString: "Ce champ devrait avoir au moins {min} caractères.",
		maxString: "Ce champ ne devrait pas avoir plus de {max} caractères.",
		email: "L'email n'est pas valide.",
		maxFileSize: "La taille maximale d'une photo est de 5 Mo.",
		fileType: "Formats autorisés - JPEG et PNG.",
		validaDate: "La date de fin doit être après la date de début.",
		testimonialsFillAll: "Veuillez remplir tous les champs afin de créer de nouveaux témoignages.",
		testimonialsMaxCount: "Vous pouvez ajouter jusqu'à 5 témoignages. Pour plus de témoignages, veuillez contacter notre <a href='mailto:feedback.drc@akkodis.com'>équipe CMT</a>.",
		serviceLines: "Le champ \"Type d'activité\" est obligatoire.",
		techPractices: "Le domaine des pratiques technologiques est requise.",
		links: "Le champ de liaison externe doit être valide.",
		maxFileCount: "Vous pouvez télécharger jusqu'à 5 images.",
		industry: "L'industrie s'impose.",
		urlValid: "Vérification du format d'url : le tel qu'il est l'actuel",
		fillAllToAddLInk: "Veuillez remplir tous les champs afin de créer un nouveau lien",
		translationsValidationsError: "Veuillez approuver ou mettre à jour toutes les sections ci-dessus.",
		theFieldContainsUnallowedHtmlTags: "Le champ contient des balises HTML non autorisées..",
		cancel: "Annuler",
		continue: "Continuer",
		validationFormResetFieldMessage: "Êtes-vous sûr de vouloir le réinitialiser? Les modifications seront perdues.",
		jobTitle: 'Titre d\'emploi',
		authorName: 'Nom de l\'auteur',
		tooLong2000: "Ce champ ne devrait pas avoir plus de 2000 caractères.",
		tooLong10000: "Ce champ ne devrait pas avoir plus de 10000 caractères.",
	},
	[LANGUAGE.ja.short]: {
		isRequired: "この項目は必須です",
		minString: "このフィールドには最低{min}文字が必要です。",
		maxString: "このフィールドには{max}文字を超えてはなりません。",
		email: "電子メールは無効です",
		maxFileSize: "写真の最大サイズは5MBです。",
		fileType: "許可形式-JPEGおよびPNG。",
		validaDate: "終了日は開始日になる必要があります。",
		testimonialsFillAll: "新しい証言を作成するために、すべてのフィールドに記入してください。」",
		testimonialsMaxCount: "紹介文は 5 つまで追加できます。 その他の証言については、<a href='mailto:feedback.drc@akkodis.com'>CMT チーム</a>までお問い合わせください。",
		serviceLines: "業種の入力は必須です。",
		techPractices: "技術実践分野が必要です",
		links: "外部リンクフィールドは有効です",
		maxFileCount: "最大5つの画像をアップロードできます。",
		industry: "業界は必要です。",
		urlValid: "URL 形式の検証: 現在のもののまま",
		fillAllToAddLInk: "新しいリンクを作成するには、すべてのフィールドに入力してください",
		translationsValidationsError: "上記のすべてのセクションを承認または更新してください。",
		theFieldContainsUnallowedHtmlTags: "フィールドに許可されていない HTML タグが含まれています。",
		cancel: "キャンセル",
		continue: "続く",
		validationFormResetFieldMessage: "リセットしてもよろしいですか? 変更は失われます。",
		jobTitle: '役職',
		authorName: '著者名',
		tooLong2000: "このフィールドには2000文字を超えてはなりません。",
		tooLong10000: "このフィールドには10000文字を超えてはなりません。",
	},
	[LANGUAGE.es.short]: {
		isRequired: "Este campo es obligatorio.",
		minString: "Este campo debe tener al menos {min} caracteres.",
		maxString: "Este campo no debe tener más de {max} caracteres.",
		email: "El correo electrónico no es válido.",
		maxFileSize: "El tamaño máximo de una foto es de 5 MB.",
		fileType: "Formatos permitidos: JPEG y PNG.",
		validaDate: "La fecha de finalización debe ser posterior a la fecha de inicio.",
		testimonialsFillAll: "Por favor, complete todos los campos para crear un nuevo testimonio.",
		testimonialsMaxCount: "Puede agregar hasta 5 testimonios. Para más testimonios, póngase en contacto con nuestro <a href='mailto:feedback.drc@akkodis.com'>equipo CMT</a>.",
		serviceLines: "El campo \"Tipo de negocio\" es obligatorio.",
		techPractices: "El campo de prácticas tecnológicas es obligatorio.",
		links: "El campo de enlace externo debe ser válido.",
		maxFileCount: "Puede cargar hasta 5 imágenes.",
		industry: "La industria es obligatoria.",
		urlValid: "Verificación del formato de URL: tal como está el actual.",
		fillAllToAddLInk: "Por favor, complete todos los campos para crear un nuevo enlace.",
		translationsValidationsError: "Por favor, apruebe o actualice todas las secciones anteriores.",
		theFieldContainsUnallowedHtmlTags: "El campo contiene etiquetas HTML no permitidas.",
		cancel: "Cancelar",
		continue: "Continuar",
		validationFormResetFieldMessage: "¿Está seguro de que desea restablecerlo? Los cambios se perderán.",
		jobTitle: "Título del trabajo",
		authorName: "Nombre del autor",
		tooLong2000: "Este campo no debe tener más de 2000 caracteres.",
		tooLong10000: "Este campo no debe tener más de 10000 caracteres.",
	}
}
